import React from 'react';
import DOK from '../DOK';
import QuestionDependency from '../QuestionDependency';
import OptionalImage from '../../lessonPlayer/components/OptionalImage';
import HtmlComponent from '../../lessonPlayer/components/HtmlComponent';

const AlchemieTestItem = ({ model, isManuscriptShort }) => {
  console.log('AlchemieTestItem model:', model);
  return (
    <div className='element-container' id={`_${model.id}`}>
      <div className='label-value-row'>
        <div>Question Type:</div>
        <div>Alchemie Activity Item</div>
      </div>
      <div className='label-value-row'>
        <div>Question Number:</div>
        <div>{model.questionNumber}</div>
      </div>
      <div className='label-value-row'>
        <div>Point Value:</div>
        <div>{model.maxScore}</div>
      </div>
      <div className='label-value-row'>
        <div className='text-area-label'>Question:</div>
        <div className='ckeditor-text text-area'><HtmlComponent htmlStr={model.questionText} /></div>
      </div>
      <OptionalImage model={model} />
      {model.startCode && (
        <div className='label-value-row'>
          <div>Start Code:</div>
          <div>{model.startCode}</div>
        </div>
      )}
      {model.config && (
        <div className='label-value-row'>
          <div>Config:</div>
          <div>{model.config}</div>
        </div>
      )}
      {model.validation?.answers && model.validation.answers.length > 0 && (
        <div className='label-value-row'>
          <div className='text-area-label'>Answers:</div>
          <div>
            {model.validation.answers.map((answer, index) => (
              <div key={index} className='label-value-row' style={{ marginLeft: '20px', marginTop: '5px' }}>
                <div>Answer {index + 1} Goal:</div>
                <div>{answer.goal || '(empty)'}</div>
              </div>
            ))}
          </div>
        </div>
      )}
      {/* advanced options */}
      {!isManuscriptShort && (
        <>
          <QuestionDependency model={model} />
          <div className='label-value-row'>
            <div>Extra Class:</div>
            <div>{model.extraClass}</div>
          </div>
          <div className='label-value-row'>
            <div>Auto-scored:</div>
            <div>{model.autoScore.toString()}</div>
          </div>
        </>
      )}
      {!isManuscriptShort && (
        <>
          <div className='label-value-row'>
            <div>Survey Question:</div>
            <div>{(model.survey) ? 'ON' : 'OFF'}</div>
          </div>
          <div className='label-value-row'>
            <div>Do Not Score:</div>
            <div>{(model.unscored) ? 'ON' : 'OFF'}</div>
          </div>
          <DOK model={model} />
        </>
      )}
    </div>
  );
};

export default AlchemieTestItem;

